import React from 'react';

import { CurrencyInputMask } from './styles';

export const CurrencyInput = ({ $hasAnError, ...props }) => {
    return (
        <CurrencyInputMask
            disableAbbreviations={true}
            $hasAnError={$hasAnError}
            intlConfig={{
                locale: 'pt-BR',
                currency: 'BRL'
            }}
            {...props}
        />
    );
};
